import React, { Suspense, lazy } from 'react';
import { HeaderBar } from './components/HeaderBar';
import { HeroSection } from './components/HeroSection';
import { MetaPixel } from './components/MetaPixel';
// Lazy load components below the fold for faster initial render
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const EbookContents = lazy(() => import('./components/EbookContents').then(m => ({
  default: m.EbookContents
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const CouplesTestimonials = lazy(() => import('./components/CouplesTestimonials').then(m => ({
  default: m.CouplesTestimonials
})));
const AboutPaula = lazy(() => import('./components/AboutPaula').then(m => ({
  default: m.AboutPaula
})));
const OfferBonuses = lazy(() => import('./components/OfferBonuses').then(m => ({
  default: m.OfferBonuses
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const FloatingCTA = lazy(() => import('./components/FloatingCTA').then(m => ({
  default: m.FloatingCTA
})));
const SalesNotification = lazy(() => import('./components/SalesNotification').then(m => ({
  default: m.SalesNotification
})));
export function App() {
  return <div className="min-h-screen flex flex-col selection:bg-gold-main/30 selection:text-brown-dark" data-id="element-0" data-mp="3dlnukh6yz1yt">
      <MetaPixel data-id="element-1" data-mp="nur8c681cizz" />
      <HeaderBar data-id="element-2" data-mp="nvaszup2llhp" />
      <main className="flex-grow" data-id="element-3" data-mp="nxwv3et6z8sj">
        <HeroSection data-id="element-4" data-mp="stufbw7kszal" />
        <Suspense fallback={<div className="h-32 bg-cream-light" data-id="element-6" data-mp="sssskuh76od1" />} data-id="element-5" data-mp="stc7017n2umb">
          <ProblemSection data-id="element-7" data-mp="35ymodf6r9ya" />
          <EbookContents data-id="element-8" data-mp="356wji4cy4fe" />
          <Testimonials data-id="element-9" data-mp="38kw6ilmzzj5" />
          <CouplesTestimonials data-id="element-10" data-mp="3ud1g7bihxsbo" />
          <AboutPaula data-id="element-11" data-mp="3ubri4mbn8k51" />
          <OfferBonuses data-id="element-12" data-mp="3ucjcxuxf2du9" />
          <Guarantee data-id="element-13" data-mp="3uf5lnxw1mze2" />
          <FAQ data-id="element-14" data-mp="d57h17dyqql6" />
          <FinalCTA data-id="element-15" data-mp="d3mlbefwx1lq" />
        </Suspense>
      </main>
      <Suspense fallback={null} data-id="element-16" data-mp="d2bgrcen7ptk">
        <Footer data-id="element-17" data-mp="851hl51gbzsj" />
        <FloatingCTA data-id="element-18" data-mp="86mc4unrniqe" />
        <SalesNotification data-id="element-19" data-mp="86cmx9ajpflr" />
      </Suspense>
    </div>;
}